/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_EndInputs */

const cs_property_legal_end = /** @type {(inputs: Property_Legal_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

const en_property_legal_end = /** @type {(inputs: Property_Legal_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End date`)
};

/**
* | output |
* | --- |
* | "End date" |
*
* @param {Property_Legal_EndInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_end = /** @type {((inputs?: Property_Legal_EndInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_EndInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_end(inputs)
	return cs_property_legal_end(inputs)
});